export enum TransactionBalancePaymentType {
	NotSet = 0,
	FullPayment = 1,
	ShortPayment = 2, 
	OverPayment = 3
}
